import React from 'react';
import styles from './MemberRow.module.scss';

const MemberRow = ({ name, path, profilePicturePath }) => {
  return (
    <a className={styles.memberRow} href={path} target="_blank" rel="noopener noreferrer">
      <img
        className={styles.memberProfilePicture}
        src={profilePicturePath || '/default-profile-picture.png'}
        alt={`${name}'s profile`}
      />
      <span className={styles.memberName}>{name}</span>
    </a>
  );
};

export default MemberRow;
